import { useState, useEffect, useContext } from 'react';
import { Container, Paper, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SCWall from './scProfile/SCWall';
import { AppContext } from '../../sporttia/AppContext';
import Page404 from '../Page404';

interface SportCenter {
    id: number;
    name: string;
    status: string;
}

/**
 * Wall page - Sports Center public wall
 * Displays posts from the sports center wall where users can view and interact
 */
export default function Wall() {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();

    const [sc, setSC] = useState<SportCenter | null>(null);

    const scId = cxt?.sc?.id;

    // Load sport center data
    useEffect(() => {
        if (scId && !sc) {
            cxt.api('GET', `/scs/${scId}`, {
                success: (r: { sc: SportCenter }) => {
                    setSC(r.sc);
                },
            });
        }
    }, [scId]);

    // Set header title
    useEffect(() => {
        if (scId) {
            cxt.setHeader({ title: t('scProfile.wall') });
        }
    }, [scId]);

    // Show 404 if SC is inactive
    if (sc?.status === 'INACTIVE') {
        return <Page404 />;
    }

    // Show nothing while loading
    if (!sc) {
        return null;
    }

    return (
        <Container maxWidth="md" className="py-6">
            <Paper className="p-4">
                {/* El título lo pinta la cabecera compartida a partir de
                    cxt.setHeader() */}
                <Box>
                    <SCWall scId={scId} />
                </Box>
            </Paper>
        </Container>
    );
}
